import {ConfirmTranslate} from './ConfirmTranslate';
import {TInitModule} from "../../interface"
import {ButtonFunctions} from "@app/modules/ConfirmTranslate/components/ButtonFunctions";


export function init(): TInitModule {
    return {
        component: ConfirmTranslate,
        buttonFunctions: ButtonFunctions
    }
}
